<script setup lang="ts">
//import { useLangsStore } from "~~/base/app/stores/langs"

const LangsStore = useLangsStore()

const columns = [
	{
		label: "Resources",
		children: [
			{
				label: "Help center",
			},
			{
				label: "Docs",
			},
			{
				label: "Roadmap",
			},
			{
				label: "Changelog",
			},
		],
	},
	{
		label: "Features",
		children: [
			{
				label: "Affiliates",
			},
			{
				label: "Portal",
			},
			{
				label: "Jobs",
			},
			{
				label: "Sponsors",
			},
		],
	},
	{
		label: "Company",
		children: [
			{
				label: "About",
			},
			{
				label: "Pricing",
			},
			{
				label: "Careers",
			},
			{
				label: "Blog",
			},
		],
	},
]

const toast = useToast()

const email = ref("")
const loading = ref(false)

function onSubmit() {
	loading.value = true

	toast.add({
		title: "Subscribed!",
		description: "You've been subscribed to our newsletter.",
	})
}
</script>

<template>
	<!-- <USeparator class="h-px" /> -->

	<UFooter :ui="{ top: 'border-b border-default' }">
		<!-- <template #top>
			<UContainer>
				<UFooterColumns :columns="columns">
					<template #right>
						<form @submit.prevent="onSubmit">
							<UFormField
								name="email"
								label="Subscribe to our newsletter"
								size="lg"
							>
								<UInput
									v-model="email"
									type="email"
									class="w-full"
									placeholder="Enter your email"
								>
									<template #trailing>
										<UButton
											type="submit"
											size="xs"
											color="neutral"
											label="Subscribe"
										/>
									</template>
								</UInput>
							</UFormField>
						</form>
					</template>
				</UFooterColumns>
			</UContainer>
		</template> -->

		<template #left> </template>

		<template #right
			><p class="text-muted text-sm">
				© Dexterial {{ new Date().getFullYear() }}.
				{{ LangsStore.getLangEntry("main_langs", "dexterial-all-rights-reserved") }}.
			</p>
		</template>
	</UFooter>
</template>
